import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getDatabase, ref, get } from 'firebase/database';

const SimpleLogin = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(loginData.email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    if (!loginData.password) {
      toast.error('Password is required');
      return;
    }

    setLoading(true);
    
    try {
      const auth = getAuth();
      const database = getDatabase();
      
      const userCredential = await signInWithEmailAndPassword(auth, loginData.email, loginData.password);
      const uid = userCredential.user.uid;

      // Check if user is admin
      const adminSnapshot = await get(ref(database, `admins/${uid}`));
      if (adminSnapshot.exists()) {
        const adminData = adminSnapshot.val();
        localStorage.setItem('userId', uid);
        localStorage.setItem('userRole', 'admin');
        localStorage.setItem('userEmail', adminData.email);
        localStorage.setItem('userName', `${adminData.firstName} ${adminData.lastName}`);
        localStorage.setItem('companyName', adminData.companyName);
        
        toast.success('Welcome Admin!');
        setTimeout(() => {
          window.location.href = '/admin-dashboard';
        }, 1000);
        setLoading(false);
        return;
      }

      // Check if user is regular user
      const userSnapshot = await get(ref(database, `users/${uid}`));
      if (userSnapshot.exists()) {
        const userData = userSnapshot.val();
        localStorage.setItem('userId', uid);
        localStorage.setItem('userRole', 'user');
        localStorage.setItem('userEmail', userData.email);
        localStorage.setItem('userName', `${userData.firstName} ${userData.lastName}`);
        
        toast.success('Login successful!');
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
        setLoading(false);
        return;
      }

      // If neither admin nor user found
      toast.error('Account not found. Please register.');
      await auth.signOut();
      setLoading(false);
      
    } catch (error) {
      setLoading(false);
      if (error.code === 'auth/user-not-found') {
        toast.error('Account not found. Please register first.');
      } else if (error.code === 'auth/wrong-password') {
        toast.error('Incorrect password');
      } else if (error.code === 'auth/invalid-email') {
        toast.error('Invalid email address format');
      } else {
        toast.error('Login failed: ' + error.message);
      }
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' }}>
      <ToastContainer />
      <div style={{ maxWidth: '500px', margin: '0 auto', paddingTop: '60px' }}>
        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '12px', 
          padding: '40px', 
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)' 
        }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <div style={{ 
              width: '60px', 
              height: '60px', 
              backgroundColor: '#3B82F6', 
              borderRadius: '50%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <span style={{ fontSize: '30px' }}>🔑</span>
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1F2937', marginBottom: '8px' }}>
              Login
            </h1>
            <p style={{ fontSize: '14px', color: '#6B7280' }}>
              Welcome back to Travel Immigration
            </p>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
                Email Address <span style={{ color: 'red' }}>*</span>
              </label>
              <input 
                type="email"
                value={loginData.email}
                onChange={(e) => setLoginData({...loginData, email: e.target.value})}
                placeholder="your@email.com"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #E5E7EB',
                  borderRadius: '10px',
                  fontSize: '14px',
                  outline: 'none'
                }}
                required
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
                Password <span style={{ color: 'red' }}>*</span>
              </label>
              <div style={{ position: 'relative' }}>
                <input 
                  type={showPassword ? 'text' : 'password'}
                  value={loginData.password}
                  onChange={(e) => setLoginData({...loginData, password: e.target.value})}
                  placeholder="••••••••"
                  style={{
                    width: '100%',
                    padding: '12px 48px 12px 12px',
                    border: '2px solid #E5E7EB',
                    borderRadius: '10px',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#9CA3AF',
                    padding: '4px'
                  }}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
            
            <button 
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                borderRadius: '8px',
                fontWeight: 600,
                color: 'white',
                fontSize: '16px',
                border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                backgroundColor: loading ? '#9CA3AF' : '#3B82F6'
              }}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
          
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <p style={{ color: '#6B7280', fontSize: '14px' }}>
              Don't have an account? <a href="/register" style={{ color: '#2563EB', fontWeight: 600 }}>Register here</a>
            </p>
          </div>

          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <a href="/admin-login" style={{ color: '#dc2626', fontSize: '14px', textDecoration: 'none' }}>
              Admin Login →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleLogin;
